import users from 'modules/core/store/collections/users'

export default () => users.current.policy.can('permissions.insightsSeeInsights')
